export interface IListItem {
  fs_id: number; // 文件在云端的唯一标识ID
  path: string; // 文件的绝对路径
  server_filename: string; // 文件名称
  real_category: string; // 文件类型
  size: number; // 文件大小，单位B
  server_mtime: number; // 文件在服务器修改时间
  server_ctime: number; // 文件在服务器创建时间
  local_mtime: number; // 文件在客户端修改时间
  local_ctime: number; // 文件在客户端创建时间
  isdir: number; // 是否为目录，0 文件、1 目录
  category: number; // 文件类型，1 视频、2 音频、3 图片、4 文档、5 应用、6 其他、7 种子
  dir_empty: number; // 该目录是否存在子目录，只有请求参数web=1且该条目为目录时，该字段才存在， 0为存在， 1为不存在
  md5: string; // 云端哈希（非文件真实MD5），只有是文件类型时，该字段才存在
  thumbs: {
    url1: string; // 缩略图URL
    url2: string; // 缩略图URL
    url3: string; // 缩略图URL
  }; // 只有请求参数web=1且该条目分类为图片时，该字段才存在，包含三个尺寸的缩略图URL
}

export enum EFROM {
  INDEX = 'index',
  FOLDER = 'folder',
  EMPTY_FOLDER = 'empty_folder', // 空文件夹，显示自动创建文件夹的头部提示条
} // index-作品页 folder-目录页
